module.exports = __webpack_public_path__ + "img/kmd.5ad4630c.svg";